<template>
	<div class="describe">
		<div class="container">
			<div class="content">
				<p>产品名称：10寸云对讲智能终端</p>
				<p>显示屏 ：10.1英寸IPS液晶屏 </p>
				<p>材质 ：铝合金拉丝</p>
				<p>外形尺寸：270X380X12mm</p>
				<p>安装尺寸：256X371X43mm</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:'describe'
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
.describe{
	.content{
		padding: 25px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ProductCenter/PDcom/Describe.vue